export default __webpack_public_path__ + "static/media/completed.7ee33752.svg";